import { createContext } from "react";
import { StoreApi } from "zustand";

import { ActivityCompareStoreType } from "./activity_compare_store.types";

type ActivityCompareStoreContextType = StoreApi<ActivityCompareStoreType>;

export const ActivityCompareStoreContext = createContext<ActivityCompareStoreContextType>(
  {} as ActivityCompareStoreContextType
);
